import 'survey-core/modern.min.css';
import { StylesManager, Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import preSurveyJsonEn from './preSurveyJsonEn';
import { useLocation, useNavigate } from 'react-router-dom';
import * as SurveyCore from "survey-core";
import { nouislider } from "surveyjs-widgets";
import "nouislider/dist/nouislider.css";
import { DONATION_MODE, DONATION_MODES } from './config';
import axios from 'axios';

nouislider(SurveyCore);
// Apply the theme to SurveyJS
StylesManager.applyTheme('modern');

const API_URL = process.env.REACT_APP_API_URL_2 || 'https://api.dbackup.cloud';

const SurveyComponent = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Extract all required query parameters
  const cid = queryParams.get('cid');

  // Prolific params (legacy)
  const prolificPid = queryParams.get('PROLIFIC_PID');
  const studyId = queryParams.get('STUDY_ID');
  const sessionId = queryParams.get('SESSION_ID');

  // Clickworker params (new)
  const clickworkerUser = queryParams.get('user');
  const clickworkerUserId = queryParams.get('user_id');
  const clickworkerTaskId = queryParams.get('task_id');
  const clickworkerJobId = queryParams.get('job_id');

  const navigate = useNavigate();

  // Optionally, check if all parameters are present
  // if (!cid || !prolificPid || !studyId || !sessionId) {
  //   return <PageNotFound />;
  // }

  const surveyJson = JSON.parse(preSurveyJsonEn());

  const survey = new Model(surveyJson);

  survey.onComplete.add(async (result) => {
    // Use Clickworker user_id as the effective user ID
    const effectiveUserId = clickworkerUserId || prolificPid || cid;

    // Include all parameters in the survey data (Prolific + Clickworker)
    const surveyData = {
      ...result.data,
      cid,
      // Prolific params (legacy)
      PROLIFIC_PID: prolificPid,
      STUDY_ID: studyId,
      SESSION_ID: sessionId,
      // Clickworker params (new)
      clickworker_user: clickworkerUser,
      clickworker_user_id: clickworkerUserId,
      clickworker_task_id: clickworkerTaskId,
      clickworker_job_id: clickworkerJobId,
    };

    try {
      // Save survey data
      await fetch(`${API_URL}/survey`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(surveyData),
      });
      console.log('Survey saved successfully');

      // Initialize Clickworker session if we have Clickworker params
      if (clickworkerUserId) {
        try {
          await axios.post(`${API_URL}/clickworker/init`, {
            clickworker_user: clickworkerUser,
            clickworker_user_id: clickworkerUserId,
            task_id: clickworkerTaskId,
            job_id: clickworkerJobId,
            cid: cid,
          });
          console.log('Clickworker session initialized');
        } catch (err) {
          console.error('Failed to init Clickworker session:', err);
        }
      }

      // Track survey completion step
      if (effectiveUserId) {
        try {
          await axios.post(`${API_URL}/track/step`, {
            user_id: effectiveUserId,
            step_name: 'survey',
            donation_type: 'both', // Survey applies to both flows
            status: 'completed',
            metadata: {
              clickworker_user: clickworkerUser,
              clickworker_user_id: clickworkerUserId,
              clickworker_task_id: clickworkerTaskId,
              clickworker_job_id: clickworkerJobId,
              cid: cid,
            }
          });
          console.log('Survey step tracked');
        } catch (err) {
          console.error('Failed to track survey step:', err);
        }
      }

      // Construct the new query string with all parameters
      const newQueryString = new URLSearchParams();

      // Include all Prolific parameters (legacy)
      if (cid) newQueryString.set('cid', cid);
      if (prolificPid) newQueryString.set('PROLIFIC_PID', prolificPid);
      if (studyId) newQueryString.set('STUDY_ID', studyId);
      if (sessionId) newQueryString.set('SESSION_ID', sessionId);

      // Include all Clickworker parameters
      if (clickworkerUser) newQueryString.set('user', clickworkerUser);
      if (clickworkerUserId) newQueryString.set('user_id', clickworkerUserId);
      if (clickworkerTaskId) newQueryString.set('task_id', clickworkerTaskId);
      if (clickworkerJobId) newQueryString.set('job_id', clickworkerJobId);

      // Use user_id as the email identifier for the donation flow
      if (clickworkerUserId) {
        newQueryString.set('email', clickworkerUserId);
      }

      const donationPath = DONATION_MODE === DONATION_MODES.CHATGPT_ONLY ? '/chatgpt-steps' : '/donate';

      // Redirect to the configured donation page with the updated query string
      navigate(`${donationPath}?${newQueryString.toString()}`);
    } catch (error) {
      console.error('Error saving survey:', error);
    }
  });

  return (
    <div>
      <h1>Data Donation Survey</h1>
      <Survey model={survey} />
    </div>
  );
};

export default SurveyComponent;
